// Virus-scan status helpers. The backend scans uploads in the background and
// stamps each attachment with scanStatus. Only 'infected' changes what we
// render: the object is deleted server-side (url/pdfUrl come back null), so
// there is nothing to preview or download. Every other state (pending,
// scanning, clean, error, unscanned) renders exactly as before, with no badge,
// so claimants are not distracted by scans that almost always pass.

export const CLAIMANT_INFECTED_MESSAGE =
  "This file failed the virus scan and was removed. Please upload a different copy.";
export const REVIEWER_INFECTED_MESSAGE = "Removed - failed virus scan";

// Older API responses carry no scanStatus; treat those as 'unscanned' so they
// keep rendering normally.
export const getScanStatus = (attachment) =>
  (attachment && typeof attachment === "object" && attachment.scanStatus) ||
  "unscanned";

export const isInfected = (attachment) =>
  getScanStatus(attachment) === "infected";
